import { parseISO, format, formatISO, addDays, startOfToday, addYears } from 'date-fns'

const LOCAL_STORAGE_DATE_FORMAT = 'yyyy-MM-dd'

function formatDatePickerPlaceholder(date?: string | Date, yearsFormat = 'yy') {
  if (!date) return ''

  let date_: Date
  if (typeof date === 'string') date_ = baseParseDateString(date)
  else date_ = date

  return format(date_, 'd/M/' + yearsFormat)
}

function getDefaultDetesRange() {
  let dateFrom_ = addDays(startOfToday(), 1)
  let dateTo_ = addDays(dateFrom_, 1)

  return { from: dateFrom_, to: dateTo_ }
}

function getMaxDatePicker() {
  return addYears(new Date(), 10)
}

function addDaysToDate(date: Date, days = 1) {
  return baseFormatDate(addDays(date, days))
}

function addDaysToDateString(date: string, days = 1) {
  return addDaysToDate(baseParseDateString(date), days)
}

function baseParseDateString(date: string) {
  return parseISO(date)
}

function baseFormatDate(date: Date) {
  return formatISO(date)
}

function formatDateForQueryString(date: Date) {
  return format(date, 'yyyy-MM-dd')
}

export const dateService = {
  LOCAL_STORAGE_DATE_FORMAT,
  formatDatePickerPlaceholder,
  getMaxDatePicker,
  addDaysToDate,
  addDaysToDateString,
  getDefaultDatesRange: getDefaultDetesRange,
  baseParseDateString,
  baseFormatDate,
  formatDateForQueryString,
}
